
import { RichTextEditor } from "./RichTextEditor"
import { Button } from "@/components/ui/button"

interface DocumentEditorProps {
  content: string;
  onSave: () => void;
  onCancel: () => void;
  onChange: (content: string) => void;
}

export function DocumentEditor({ content, onSave, onCancel, onChange }: DocumentEditorProps) {
  return (
    <div className="flex-1 overflow-hidden flex flex-col">
      <div className="flex-1 min-h-0">
        <RichTextEditor content={content} onChange={onChange} />
      </div>
      <div className="flex flex-col sm:flex-row justify-end gap-2 mt-4 pt-4 border-t">
        <Button
          variant="outline"
          onClick={onCancel}
          className="w-full sm:w-auto"
        >
          Cancelar
        </Button>
        <Button 
          onClick={onSave}
          className="w-full sm:w-auto bg-primary hover:bg-primary/90 text-white"
        >
          Salvar alterações
        </Button>
      </div>
    </div>
  )
}
